import axiosInstance from "./AxiosInstanceMain";

export const getFbPagesApi = async () => {
  const res = await axiosInstance.get("/admin/fb-pages");
  return res.data;
};